import { Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { UnusedSinceDurationCellRenderer } from "../column-def-cell-renderers/unused-since/UnusedSinceDurationCellRenderer";
import type { ColDef, ICellRendererParams } from "ag-grid-community";
import { UnusedSince } from "@/services/cloudchipr.api";

export const resourceUnusedSinceCellRenderer: ColDef = {
  field: "resource.unused_since",
  headerName: "State",
  valueGetter: ({ data }) =>
    data?.resource?.unused_since?.is_used ? "Running" : "Stopped",
  comparator: (_, __, nodeA, nodeB) => {
    const dataA = nodeA?.data?.resource?.unused_since;
    const dataB = nodeB?.data?.resource?.unused_since;

    if (dataA.is_used && !dataB.is_used) return -1;
    if (dataB.is_used && !dataA.is_used) return 1;

    if (!dataA.is_used && !dataB.is_used) {
      return dataB.timestamp - dataA.timestamp;
    }

    return 0;
  },
  cellRenderer: ({ data }: ICellRendererParams) => {
    if (!data) {
      return null;
    }

    const unusedSince = data?.resource?.unused_since as UnusedSince;

    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        {unusedSince?.is_used ? (
          <CheckCircleOutlineIcon color="success" fontSize="small" />
        ) : (
          <RemoveCircleOutlineIcon color="action" fontSize="small" />
        )}

        <Stack>
          <Typography variant="body2">
            {unusedSince?.is_used ? "Running" : "Stopped"}
          </Typography>

          {!unusedSince?.is_used && unusedSince?.timestamp && (
            <UnusedSinceDurationCellRenderer
              data={unusedSince}
              variant="caption"
            />
          )}
        </Stack>
      </Stack>
    );
  },
};
